module.exports = {
  masterpassword: 'rewaco24',
  //apihost: 'localhost:8070',
  //protocol: 'http',
  //filedelivery: 'http://localhost:8070/files',
  apihost: 'api.rewaco.com',
  protocol: 'https',
  filedelivery: 'https://api.rewaco.com/files',
  countries: [{
    de: 'Deutschland',
    kv: 'de'
  }, {
    de: 'Frankreich',
    kv: 'fr'
  }, {
    de: 'England',
    kv: 'gb uk'
  }, {
    de: 'Schweiz',
    kv: 'ch'
  }, {
    de: 'Spanien',
    kv: 'es'
  }, {
    de: 'Amerika',
    kv: 'us'
  }]
}
